var React = require('react');

function HeartOutline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.722 21.158c.556-.597 4.18-4.516 5.524-5.958a4.741 4.741 0 0 0-.117-6.584 4.523 4.523 0 0 0-6.397 0l-1.607 1.607a1.5 1.5 0 0 1-2.121 0l-1.607-1.607a4.523 4.523 0 0 0-6.397 0 4.741 4.741 0 0 0-.117 6.584c1.376 1.477 4.85 5.428 5.343 5.958a137.027 137.027 0 0 0 3.825 3.919c1.416-1.506 2.64-2.812 3.67-3.919zM16.064 7.041l.546-.546a7.523 7.523 0 0 1 10.64 0 7.741 7.741 0 0 1 .191 10.75c-1.338 1.437-4.963 5.355-5.524 5.958-1.118 1.2-2.461 2.633-4.023 4.293a2.5 2.5 0 0 1-3.533.126c-.065-.062-.065-.062-.08-.08a142.115 142.115 0 0 1-4.25-4.34c-.533-.571-4.007-4.522-5.343-5.957a7.741 7.741 0 0 1 .19-10.75 7.523 7.523 0 0 1 10.64 0l.546.546z"}));
}

HeartOutline.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = HeartOutline;

HeartOutline.default = HeartOutline;
